import { render, staticRenderFns } from "./customerAccount.vue?vue&type=template&id=a27af1aa&scoped=true&"
import script from "./customerAccount.vue?vue&type=script&lang=js&"
export * from "./customerAccount.vue?vue&type=script&lang=js&"
import style0 from "./customerAccount.vue?vue&type=style&index=0&id=a27af1aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27af1aa",
  null
  
)

export default component.exports